import Cookies from 'js-cookie';
import { axiosInstances } from '../axios-instances';
import { useMutation, useQueryClient } from 'react-query';
import { message } from 'antd';

export const makePayment = async ({ cityId, dateFrom, dateTo, amount }) => {
    const token = Cookies.get('token');
    if (!token) throw new Error('Token is not available');

    const response = await axiosInstances.post(
        '/amantrans/statistics/make-payment',
        {},
        {
            params: { cityId, startDate: dateFrom, endDate: dateTo, amount },
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        },
    );

    if (response.status !== 200) throw new Error(`Error: ${response.status}`);
    return response.data;
};

export const useMakePayment = () => {
    const queryClient = useQueryClient();

    return useMutation(makePayment, {
        onSuccess: () => {
            message.success('Платёж успешно проведён');
            queryClient.invalidateQueries('getReportFilial');
            queryClient.invalidateQueries('getSummary');
        },
        onError: () => {
            message.error('Не удалось выполнить платёж');
        },
    });
};
export const getOrders = async ({ queryKey }) => {
    const [, { cityId, dateFrom, dateTo, plagination }] = queryKey;
    const today = new Date();
    const threeMonthsAgo = new Date(today);
    threeMonthsAgo.setMonth(today.getMonth() - 3);
    const formattedDateFrom = dateFrom || threeMonthsAgo.toISOString().split('T')[0];
    const addOneDay = (date) => {
        const newDate = new Date(date);
        newDate.setDate(newDate.getDate() + 1);
        return newDate.toISOString().split('T')[0];
    };
    const formattedDateTo = dateTo ? addOneDay(dateTo) : addOneDay(today);
    const token = Cookies.get('token');
    if (!token) {
        throw new Error('Token is not available');
    }
    const response = await axiosInstances.get('/amantrans/statistics/my-city', {
        params: {
            startDate: formattedDateFrom,
            endDate: formattedDateTo,
            cityId: cityId,
            page: plagination,
        },
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    });
    if (response.status !== 200) {
        throw new Error(`Error: ${response.status}`);
    }
    return response.data;
};

export const getSummary = async ({ queryKey }) => {
    const [, { cityId, dateFrom, dateTo, plagination }] = queryKey;
    const today = new Date();
    const threeMonthsAgo = new Date(today);
    threeMonthsAgo.setMonth(today.getMonth() - 3);
    const formattedDateFrom = dateFrom || threeMonthsAgo.toISOString().split('T')[0];
    const addOneDay = (date) => {
        const newDate = new Date(date);
        newDate.setDate(newDate.getDate() + 1);
        return newDate.toISOString().split('T')[0];
    };
    const formattedDateTo = dateTo ? addOneDay(dateTo) : addOneDay(today);
    const token = Cookies.get('token');
    if (!token) {
        throw new Error('Token is not available');
    }
    const response = await axiosInstances.get('/amantrans/statistics/all-cities', {
        params: {
            startDate: formattedDateFrom,
            endDate: formattedDateTo,
            cityId: cityId,
            page: plagination,
        },
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    });
    if (response.status !== 200) {
        throw new Error(`Error: ${response.status}`);
    }
    return response.data;
};
export const downloadFile = async ({ dateFrom, dateTo }) => {
    const today = new Date();
    const threeMonthsAgo = new Date();
    threeMonthsAgo.setMonth(today.getMonth() - 3);
    const from = dateFrom || threeMonthsAgo.toISOString().split('T')[0];
    const addDay = (d) => {
        const n = new Date(d);
        n.setDate(n.getDate() + 1);
        return n.toISOString().split('T')[0];
    };
    const to = dateTo ? addDay(dateTo) : addDay(today);
    const token = Cookies.get('token');
    if (!token) throw new Error('Token is not available');
    const body = { startDate: from, endDate: to };
    const r = await axiosInstances.post('/amantrans/filial', body, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        responseType: 'blob',
    });
    let fileName = 'report.xlsx';
    const disp = r.headers['content-disposition'];
    if (disp && disp.includes('filename='))
        fileName = disp.split('filename=')[1].replace(/["']/g, '');
    return { blob: r.data, fileName };
};

export const useDownloadFile = () =>
    useMutation(downloadFile, {
        onError: () => message.error('Ошибка при скачивании файла'),
    });
